import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DevicesService } from 'src/app/services/devices/devices.service';
import { DropdownsService } from 'src/app/services/dropdowns/dropdowns.service';
import { Dropdown } from 'src/app/models/dropdown.model';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-inventory',
  templateUrl: './update-inventory.component.html',
  styleUrls: ['./update-inventory.component.scss']
})
export class UpdateInventoryComponent implements OnInit {

  public faCalendarAlt = faCalendarAlt;
  
  public isSearchSubmitted = false;
  public isSubmitted = false;
  public deviceGroups: Dropdown[];
  public deviceTypes: Dropdown[];
  public sensorProfiles: Dropdown[];
  public statuses: Dropdown[];

  constructor(private _fb: FormBuilder, private _devicesService: DevicesService, private _dropdownService: DropdownsService, private _toastr : ToastrService) { }

  public formDevice: FormGroup;
  public formSearch: FormGroup;

  ngOnInit() {
    this._createForm();
    this._getDeviceGroups();
    this._getDeviceTypes();
    this._getSensorProfiles();
    this._getStatuses();
  }

  private _createForm(){

    this.formSearch = this._fb.group({
      deviceId: [null, Validators.required]
    });

    this.formDevice = this._fb.group({
      deviceId: [{value: null, disabled: true}, [Validators.required]],
      deviceGroup: null,
      deviceType: null,
      sensorProfile: null,
      hwRevision: null,
      fwRevision: null,
      startOfService: null,
      endOfLifecycle: null,
      endOfLicense: null,
      statusId: null
    });
  }

  private _getDeviceGroups() {
    this._dropdownService.getDeviceGroups().subscribe(res => {
      this.deviceGroups = res;
      this.formDevice.controls['deviceGroup'].setValue(this.deviceGroups[0].code);
    });
  }

  private _getDeviceTypes() {
    this._dropdownService.getDeviceTypes().subscribe(res => {
      this.deviceTypes = res;
      this.formDevice.controls['deviceType'].setValue(this.deviceTypes[0].code);
    });
  }

  private _getSensorProfiles() {
    this._dropdownService.getSensorProfiles().subscribe(res => {
      this.sensorProfiles = res;
      this.formDevice.controls['sensorProfile'].setValue(this.sensorProfiles[0].code);
    });
  }

  private _getStatuses() {
    this._dropdownService.getStatuses().subscribe(res => {
      this.statuses = res;
      this.formDevice.controls['statusId'].setValue(this.statuses[0].code);
    });
  }

  onSearch() {
    this.isSearchSubmitted = true;
    if(this.formSearch.invalid){return}
    this._devicesService.getById(this.formSearch.controls['deviceId'].value).subscribe(res => {
      this.formDevice.reset(res);
    });
  }

  onSubmit(){
    this.isSubmitted = true;
    if(this.formDevice.invalid){return}
    this._devicesService.update(this.formDevice.getRawValue()).subscribe(res => {
      this._toastr.success('Inventory updated successfully.', '',{ timeOut: 3000 });
    });
  }

  onReset() {
    this.isSubmitted = false;
    this.formDevice.reset();
    this.formDevice.markAsPristine();
    this.formDevice.controls['deviceGroup'].setValue(this.deviceGroups[0].code);
    this.formDevice.controls['deviceType'].setValue(this.deviceTypes[0].code);
    this.formDevice.controls['sensorProfile'].setValue(this.sensorProfiles[0].code);
  }

  get f(){ return this.formDevice.controls }
  get s(){ return this.formSearch.controls}

}
